import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const faqs = [
  {
    question: 'Como a dgenny encontra fornecedores?',
    answer:
      'A dgenny mapeia fornecedores relevantes em diretórios, marketplaces e bases do seu segmento, filtra os que têm WhatsApp ativo e inicia o contato — sem planilha, sem telefonema.',
  },
  {
    question: 'Quantas contas de WhatsApp posso conectar?',
    answer:
      'Depende do plano: Advanced (5), Pro (10), Premium (15). Se precisar de mais, adiciona contas extras por R$ 50/mês cada uma em qualquer plano.',
  },
  {
    question: 'E se eu passar do limite de negociações?',
    answer:
      'Sem travar nada. Você compra pacotes adicionais — R$ 149/100 no Advanced, R$ 119 no Pro, R$ 99 no Premium. No PremiumPlus, as condições são negociadas direto.',
  },
  {
    question: 'A dgenny substitui meu comprador?',
    answer:
      'Não. A dgenny assume o trabalho repetitivo — busca, primeiro contato, cotação, equalização. Seu comprador decide. É parceria, não substituição.',
  },
  {
    question: 'Como integra com meus sistemas?',
    answer:
      'Nos planos Pro e Premium integramos com ERP e CRM. Nos planos menores, a dgenny opera independente e exporta os dados. A nossa equipe faz o escopo junto com você.',
  },
  {
    question: 'Quanto tempo até estar operando?',
    answer:
      'Setup básico em dias. Implantações com integração (Pro/Premium) ficam em 2 a 4 semanas. Você fala com um time técnico — não com um bot.',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-20 md:py-28 bg-muted/50">
      <div className="container px-4 mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-14">
            <span className="inline-block text-brand-roxo font-semibold text-sm uppercase tracking-wider mb-3">
              Perguntas Frequentes
            </span>
            <h2 className="font-display text-3xl md:text-5xl font-extrabold text-brand-azul mb-4 leading-tight">
              Resposta direta. Sem rodeio.
            </h2>
          </div>

          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-border rounded-2xl px-5 bg-white"
              >
                <AccordionTrigger className="text-left font-semibold text-brand-azul hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-brand-azul/70 pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
